import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import { default as PinnedLocation } from './PinnedLocation';
import LocationService from '../services/LocationService';

const bootstrapURLKeys = {
  key: 'AIzaSyBrnGaFIUXLBr2SSU_whpBZv_1j69RtklE',
};

const ProviderMap = ({
  zoom,
  results,
  resultsLimit,
  latitude,
  longitude,
  mapLoading,
  defaultLatitude,
  defaultLongitude,
  hoveredResultId,
  selectedResultId,
  setUserCoordinates,
  openResultInfoWindow,
  setPage,
  setHoveredResultId,
  setSelectedResultId,
}) => (
  <div className="find-a-doctor__provider-map-container">
    <div className={`find-a-doctor__provider-map ${mapLoading ? 'find-a-doctor__provider-map--loading' : ''}`}>
      <GoogleMapReact
        yesIWantToUseGoogleMapApiInternals
        bootstrapURLKeys={bootstrapURLKeys}
        defaultCenter={{ lat: defaultLatitude, lng: defaultLongitude }}
        zoom={zoom}
        center={{ lat: latitude, lng: longitude }}
        onGoogleApiLoaded={LocationService.initGoogleMaps.bind(LocationService)}
      >
        {
          results.map((result, i) => (
            <PinnedLocation
              key={i}
              resultsLimit={resultsLimit}
              displayIndex={i + 1}
              lat={result.location.latitude}
              lng={result.location.longitude}
              setPage={setPage}
              setUserCoordinates={setUserCoordinates}
              openResultInfoWindow={openResultInfoWindow}
              hoveredResultId={hoveredResultId}
              selectedResultId={selectedResultId}
              setHoveredResultId={setHoveredResultId}
              setSelectedResultId={setSelectedResultId}
              {...result}
            />
          ))
        }
      </GoogleMapReact>
    </div>
    <div className={`${mapLoading ? '' : 'find-a-doctor__loading-overlay--inactive'}`}>
      <div className="find-a-doctor__loading-overlay__animation opt-loading opt-loading--block opt-loading--dark">
        <div /><div /><div />
      </div>
    </div>
  </div>
);

ProviderMap.propTypes = {
  zoom: PropTypes.number.isRequired,
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  mapLoading: PropTypes.bool.isRequired,
  defaultLatitude: PropTypes.number.isRequired,
  defaultLongitude: PropTypes.number.isRequired,
  hoveredResultId: PropTypes.number,
  selectedResultId: PropTypes.number,
  setUserCoordinates: PropTypes.func.isRequired,
  openResultInfoWindow: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  setHoveredResultId: PropTypes.func.isRequired,
  setSelectedResultId: PropTypes.func.isRequired,
  results: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      opened: PropTypes.bool,
      website: PropTypes.string,
      practiceName: PropTypes.string,
      location: PropTypes.shape({
        city: PropTypes.string,
        phone: PropTypes.string,
        region: PropTypes.string,
        postal: PropTypes.string,
        address: PropTypes.string,
        latitude: PropTypes.number.isRequired,
        longitude: PropTypes.number.isRequired,
      }).isRequired,
    }),
  ),
  resultsLimit: PropTypes.number.isRequired,
};

export default ProviderMap;
